// Spoken-languages options for the lawyer-profile "Languages spoken" field.
// The stored value is the free-text language NAME (value === label), NOT an ISO
// code — the WP import (wp-syncer) writes these same names, so any row whose
// value is not in this list surfaces as an invalid option. Sorted by name.
//
// IMPORTANT: this list is a duplicate of account-ui
// (`services/account-ui/src/constants/languages.ts` — SPOKEN_LANGUAGE_OPTIONS)
// and is mirrored by the wp-syncer import. There is no shared package wiring
// these two apps together today, so the list is intentionally duplicated. Keep
// all copies character-for-character identical.
export const SPOKEN_LANGUAGE_OPTIONS: { value: string; label: string }[] = [
  { value: "Afrikaans", label: "Afrikaans" },
  { value: "Albanian", label: "Albanian" },
  { value: "Arabic", label: "Arabic" },
  { value: "Bengali", label: "Bengali" },
  { value: "Bulgarian", label: "Bulgarian" },
  { value: "Cantonese", label: "Cantonese" },
  { value: "Catalan", label: "Catalan" },
  { value: "Chinese (Mandarin)", label: "Chinese (Mandarin)" },
  { value: "Croatian", label: "Croatian" },
  { value: "Czech", label: "Czech" },
  { value: "Danish", label: "Danish" },
  { value: "Dutch", label: "Dutch" },
  { value: "English", label: "English" },
  { value: "Estonian", label: "Estonian" },
  { value: "Finnish", label: "Finnish" },
  { value: "French", label: "French" },
  { value: "German", label: "German" },
  { value: "Greek", label: "Greek" },
  { value: "Gujarati", label: "Gujarati" },
  { value: "Hebrew", label: "Hebrew" },
  { value: "Hindi", label: "Hindi" },
  { value: "Hungarian", label: "Hungarian" },
  { value: "Indonesian", label: "Indonesian" },
  { value: "Italian", label: "Italian" },
  { value: "Japanese", label: "Japanese" },
  { value: "Korean", label: "Korean" },
  { value: "Latvian", label: "Latvian" },
  { value: "Lithuanian", label: "Lithuanian" },
  { value: "Malay", label: "Malay" },
  { value: "Norwegian", label: "Norwegian" },
  { value: "Persian (Farsi)", label: "Persian (Farsi)" },
  { value: "Polish", label: "Polish" },
  { value: "Portuguese", label: "Portuguese" },
  { value: "Punjabi", label: "Punjabi" },
  { value: "Romanian", label: "Romanian" },
  { value: "Russian", label: "Russian" },
  { value: "Serbian", label: "Serbian" },
  { value: "Slovak", label: "Slovak" },
  { value: "Slovenian", label: "Slovenian" },
  { value: "Spanish", label: "Spanish" },
  { value: "Swahili", label: "Swahili" },
  { value: "Swedish", label: "Swedish" },
  { value: "Tagalog (Filipino)", label: "Tagalog (Filipino)" },
  { value: "Tamil", label: "Tamil" },
  { value: "Telugu", label: "Telugu" },
  { value: "Thai", label: "Thai" },
  { value: "Turkish", label: "Turkish" },
  { value: "Ukrainian", label: "Ukrainian" },
  { value: "Urdu", label: "Urdu" },
  { value: "Vietnamese", label: "Vietnamese" },
  { value: "Welsh", label: "Welsh" },
];
